var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8758 7.71777H3.35948C2.60866 7.71777 2 8.39198 2 9.22365V14.4942C2 15.3259 2.60866 16.0001 3.35948 16.0001H12.8758C13.6266 16.0001 14.2353 15.3259 14.2353 14.4942V9.22365C14.2353 8.39198 13.6266 7.71777 12.8758 7.71777Z",
    fill: "currentColor",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11762 1.88235C6.77432 1.88235 5.76468 2.90831 5.76468 4.07843V6.58823C5.76468 7.10803 5.3433 7.52941 4.8235 7.52941C4.3037 7.52941 3.88232 7.10803 3.88232 6.58823V4.07843C3.88232 1.78323 5.82233 0 8.11762 0C10.4129 0 12.3529 1.78323 12.3529 4.07843V6.58823C12.3529 7.10803 11.9315 7.52941 11.4117 7.52941C10.8919 7.52941 10.4706 7.10803 10.4706 6.58823V4.07843C10.4706 2.90831 9.46091 1.88235 8.11762 1.88235Z",
    fill: "currentColor",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58816 12.1551C9.13649 11.9613 9.52934 11.4383 9.52934 10.8236C9.52934 10.0439 8.89727 9.41187 8.11757 9.41187C7.33788 9.41187 6.70581 10.0439 6.70581 10.8236C6.70581 11.4383 7.09866 11.9613 7.64699 12.1551V14.1177H8.58816V12.1551Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3c054957.svg";
export { ForwardRef as ReactComponent };